'use strict';

import {projectChangeModel} from "../../models/projectchangemodel.js";
import {projectModel} from "../../models/projectmodel.js";

export class ProjectChangeCtrl
{
	$scope;
	$filter;
	$mdDialog;
	jsDataService;
	appName;
	loggedUserId;
	changes = [];

	constructor($scope, $filter, jsDataService, $mdDialog){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.$mdDialog = $mdDialog;
		this.jsDataService = jsDataService;
		this.item = new projectModel(jsDataService.get('applicationBase', {}), $filter, jsDataService);
		this.appName = jsDataService.get('cfgAppName');
		this.loggedUserId = jsDataService.get('loggedUserId');
		this.loadData();
	}

	loadData(){
			const url = this.jsDataService.get('cfgDataUrl');
			if(url){
				this.promise = this.$scope.basicHttpConfigProcess({
					url: url,
					method: 'GET',
					params: {}
				}).then((response) => {
					if(response.data.success){
						this.setData(response.data.data);
					}
				}, () => {});
			}
	}

	setData(data){
		this.changes = [];
		for(let row of data){
			this.changes.push(new projectChangeModel(row, this.$filter, this.jsDataService));
		}
	}

	canRemoveChange(change){
		switch(this.appName){
			case 'esfa':
				return change.status<11;
				break;
			case 'site':
				return (change.init_user_id==this.loggedUserId && change.status<4);
				break;
			default:
				return false;
		}
	}

	removeChange(ev, change){
		if(this.jsDataService.get('cfgRemoveUrl', '') !== ''){
			const confirmTexts = this.jsDataService.get('removeConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgRemoveUrl'),
					method: 'GET',
					responseType: 'json',
					params: {
						id: change.id
					}
				}).then((results) => {
					if(results.data.success){
						this.loadData();
					}
				});
			}, () => {});
		}
	}

//	editChange(ev, change){
//		this.changeEditor(ev, change);
//	}

	addChange(ev){
		const change = new projectChangeModel({
			type: '',
			purpose: '',
			purpose_other: '',
			message: '',
			attachment: []
		});
		this.changeEditor(ev, change);
	}

	changeEditor(ev, change){
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "$filter", "jsDataService", "change", this.changeEditorDialogCtrl],
			templateUrl: 'projects/ng_change_editor.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:true,
			fullscreen: true,
			locals: {
				change: change
			}
		}).then((results) => {
//			console.log('dialog close', results);
			if(this.jsDataService.get('cfgSaveUrl')){
				this.$scope.basicHttpConfigProcess({
					url: this.jsDataService.get('cfgSaveUrl'),
					method: 'POST',
					data: results
				}).then((response) => {
					if(response.data.success){
						this.loadData();
					}
				}, () => {});
			}
			else{
				console.log('no url ', this.jsDataService.get('cfgSaveUrl'));
			}
		}, () => {});
	}

	changeEditorDialogCtrl($scope, $mdDialog, $filter, jsDataService, change){
		$scope.change = angular.copy(change);
		$scope.appName = jsDataService.get('cfgAppName');
		$scope.classif = jsDataService.get('cfgClassif', {});
		if($scope.appName==='site'){
			$scope.classif.project_change_type = $scope.classif.project_change_type.filter(item => item.id !== '2');
		}
		$scope.projectChangeForm;
		$scope.uploadUrl = jsDataService.get('cfgUploadUrl');

		$scope.filterByType = function(purpose) {
			return Array.isArray(purpose.types) && purpose.types.includes($scope.change.type);
		};

		$scope.close = function() {
			$mdDialog.cancel();
		};

		$scope.save = function() {
			if(!this.isValid()) {
				return;
			}
			$mdDialog.hide($scope.getSaveData());
		};

		$scope.fileAdded = function ($file) {
			const file = {
				id: '0',
				file_id: '0',
				name: $file.name,
				isFlow: true,
				flowFile: $file,
			};

			$scope.change.attachment.push(file);
			return true;
		};

		$scope.fileSubmitted = function() {
			$scope.change.flow.upload();
		};

		$scope.fileUploaded = function ($file, $message) {
			const file = $scope.change.attachment.find(f => f.flowFile?.uniqueIdentifier === $file.uniqueIdentifier);

			if(!file) {
				return;
			}

			try {
				const response = JSON.parse($message);
				file.file_id = response.fileId;
				$scope.projectChangeForm['attachment'].$setViewValue(Date.now());
			} catch(err) {

			}
		};

		$scope.removeFile = function (file) {
			$scope.change.attachment = $scope.change.attachment.filter(f => f !== file);
			$scope.projectChangeForm['attachment'].$setViewValue(Date.now());
		};

		$scope.isValid = function (){
			return !$scope.change.flow.isUploading();
		};

		$scope.getSaveData = function() {
			return {
				type: $scope.change.type,
				purpose: $scope.change.purpose,
				purpose_other: (parseInt($scope.change.purpose)===8)? $scope.change.purpose_other: '',
				message: $scope.change.message,
				attachment: $scope.change.attachment.map(({id, file_id}) => ({id, file_id})),

			};
		};

	}

	go2Url(urlString){
		this.$scope.goUrl(urlString);
	}
}